import "./LostKeys.module.css";
import Header from "@/reusable_sections/Header";
import LostAllYourKeys from "./sections/LostAllYourKeys";
import TheReplacementProcess from "./sections/TheReplacementProcess";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function LostKeysPage() {
  return <div>
      <Header />
      <LostAllYourKeys />
      <TheReplacementProcess />
      <CommonQuestions />
      <Footer />
    </div>;
}